<template>
  <!-- <hm-content title=""> -->
  <div class="p10 content">
    <div class="flex flex-wrap" v-if="list.length">
      <div class="mb10 okr p10 mr10 flex-1" v-for="(v, i) in list" :key="i">
        <div class="flex item-center okr-title bor-m" style="color: #999999">
          <el-tooltip :content="v.planName" placement="top-start">
            <div class="flex-1 target-name text-overflow">
              目标：{{ v.planName }}
            </div>
          </el-tooltip>
          <el-tooltip
            :content="v.planStartDate + '至' + v.planEndDate"
            placement="top-start"
          >
            <div class="flex-1  text-center  text-overflow">
              <!-- 目标时间： -->
              {{ v.planStartDate }}{{ v.timeType === "year" ? "年" : "" }}至{{
                v.planEndDate
              }}{{ v.timeType === "year" ? "年" : "" }}
            </div>
          </el-tooltip>
          <!-- <div class="flex-1 target-value text-center">{{ v.planValue }}</div> -->
          <el-tooltip :content="v.realName" placement="top-start">
            <div class="flex-1 person-liable text-overflow">
              总目标负责人：{{ v.realName }}
            </div>
          </el-tooltip>
        </div>
        <div class="">
          <div class="flex item-center flex-between okr-title">
            <el-tooltip :content="v.planTargetName" placement="top-start">
              <div class="flex-1 target-name text-overflow">
                子目标：{{ v.planTargetName }}
              </div>
            </el-tooltip>
            <!-- <div class="flex-1 target-value">{{ v.totalSplitValue }}元</div> -->
            <el-tooltip :content="v.targetRealName" placement="top-start">
              <div class="flex-1 person-liable text-overflow">
                子目标负责人：{{ v.targetRealName }}
              </div>
            </el-tooltip>
          </div>
          <div style="width: 600px" class="mt20 mb20">
            <el-steps :active="v.active" align-center>
              <el-step
                icon="el-icon-edit"
                :title="o.title"
                v-for="(o, k) in stepList"
                :key="k"
              >
                <div slot="icon">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="
                      k + 1 < v.active
                        ? o.complete
                        : v.active === k + 1
                        ? o.doing
                        : o.disable
                    "
                    placement="top-start"
                  >
                    <div
                      class="circular flex flex-center item-center"
                      :class="{
                        'circular-active':
                          v.active <= stepList.length + 1 && v.active > k
                      }"
                    >
                      <span
                        style="font-size:22px"
                        class="hmicon"
                        :class="v.active <= k + 1 ? o.icon : 'icon-duigou'"
                      >
                      </span>
                    </div>
                  </el-tooltip>
                </div>
              </el-step>
            </el-steps>
          </div>
          <div class="mt20 ml20 mb20" style="zindex: 99999">
            <!-- <ve-histogram
            v-if="v.targetInfoModelList"
            :data="v.chartData"
            :extend="v.extend"
            :events="chartEvents"
          ></ve-histogram> -->
            <el-button
              type="success"
              size="small"
              @click="goDetails(v)"
              v-if="v.state === 'publish'"
              >查看进度</el-button
            >
            <el-button type="primary" size="small" @click="goSplit(v)" v-else
              >去拆分</el-button
            >
          </div>
        </div>
      </div>
    </div>
    <hm-content title="" v-else>
      <div class="tip-msg flex flex-wrap">
        <div class="tip-img flex flex-column flex-center item-center">
          <img
            src="https://imgcdn.hemiao100.com/ThemePictures/%E7%8C%B4%E5%AD%90.png"
            alt=""
          />
          <div class="tip-name">小助理</div>
        </div>
        <div class="bubbleItem">
          <!--左侧的泡泡-->
          <span class="bubble leftBubble">
            您当前尚未收到总部发来的计划！
            <span class="bottomLevel"></span>
            <span class="topLevel"></span>
          </span>
        </div>
      </div>
      <div class="flex flex-center">
        <el-image
          src="https://imgcdn.hemiao100.com/ThemePictures/%E7%BB%84%2089%402x.png"
        >
        </el-image>
      </div>
    </hm-content>
    <!-- <div
      v-if="list.length"
      class="mb10 okr p10"
      v-for="(v, i) in list"
      :key="i"
    >
      <div class="flex item-center okr-title bor-m" style="color: #999999">
        <div class="flex-1 target-name">目标：{{ v.planName }}</div>
        <div class="flex-1">
          目标时间：{{ v.planStartDate
          }}{{ v.timeType === "year" ? "年" : "" }}至{{ v.planEndDate
          }}{{ v.timeType === "year" ? "年" : "" }}
        </div>
        <div class="flex-1 target-value text-center">{{ v.planValue }}</div>
        <div class="flex-1 person-liable">负责人：{{ v.realName }}</div>
      </div>
      <div class="">
        <div class="flex item-center okr-title" style="width: 50%">
          <div class="flex-1 target-name">子目标：{{ v.planTargetName }}</div>
          <div class="flex-1 target-value">{{ v.totalSplitValue }}元</div>

          <div class="person-liable">负责人：张三和</div>
        </div>
        <div style="width: 600px" class="mt20">
          <el-steps :active="active" align-center>
            <el-step
              icon="el-icon-edit"
              :title="v.title"
              v-for="(o, index) in stepList"
              :key="index"
            >
              <div slot="icon">
                <div
                  class="circular flex flex-center item-center"
                  :class="{
                    'circular-active':
                      active <= stepList.length + 1 && active > index,
                  }"
                >
                  <span
                    class="hmicon"
                    :class="active <= index + 1 ? o.icon : 'icon-duigou'"
                  >
                  </span>
                </div>
              </div>
            </el-step>
          </el-steps>
        </div>
        <div class="mt20 ml20 mb20" style="zindex: 99999" @click="getIndex(i)">
          <ve-histogram
            v-if="v.targetInfoModelList"
            :data="v.chartData"
            :extend="v.extend"
            :events="chartEvents"
          ></ve-histogram>
          <el-button v-else type="primary" size="small" @click="goSplit(v)"
            >去拆分</el-button
          >
        </div>
      </div>
    </div> -->
    <!-- <div v-else>
      <div class="flex flex-center item-center">
        <el-image
          style="width: 818px; height: 680px"
          :src="url"
          fit="fit"
        ></el-image>
      </div>
      <div class="mt10 flex flex-center">
        <el-button type="primary" size="small" @click="add"
          >定制一个OKR</el-button
        >
      </div>
    </div> -->
    <el-dialog
      :title="title"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="1300px"
    >
      <div v-if="dialogVisible">
        <div
          class="flex flex-center item-center okr-title bor-m"
          style="color: #999"
        >
          <div class="flex-1 target-name">
            目标：{{ basicInfoModel.planName }}
          </div>
          <div class="flex-1 text-center">
            目标时间：{{ basicInfoModel.planStartDate
            }}{{ basicInfoModel.timeType === "year" ? "年" : "" }}至{{
              basicInfoModel.planEndDate
            }}{{ basicInfoModel.timeType === "year" ? "年" : "" }}
          </div>
          <div class="flex-1 target-value text-center">
            ￥{{ basicInfoModel.toPrice }}
          </div>
          <div class="flex-1 person-liable text-center">
            负责人：{{ basicInfoModel.realName }}
          </div>
        </div>

        <div class="flex flex-center item-center okr-title">
          <div class="flex-1 target-name">
            子目标：{{ detailInfoModel.planTargetName }}
          </div>
          <div class="flex-1 flex item-center">
            <el-progress
              style="width: 240px"
              :show-text="false"
              :stroke-width="12"
              :percentage="detailInfoModel.percentage"
            ></el-progress>
            <span class="ml10">{{ detailInfoModel.percentage }}%</span>
          </div>
          <div class="flex-1 flex flex-center target-value">
            <span
              :class="
                detailInfoModel.detailGoalTaskValue <
                detailInfoModel.detailConfirmTaskValue
                  ? 'danger'
                  : 'success'
              "
              >{{ detailInfoModel.detailGoalTaskValues }}</span
            >/{{ detailInfoModel.detailConfirmTaskValues }}
          </div>
          <div class="flex-1 target-value">
            负责人：{{ detailInfoModel.realName }}
          </div>
        </div>
        <div class="mb20">
          <el-table
            :data="goodsList"
            style="width: 100%"
            border
            stripe
            size="small"
            :tree-props="{
              children: 'children',
              hasChildren: 'isHaveChildren'
            }"
            :header-cell-style="{ background: '#f1f1f1', color: '#606266' }"
            :max-height="400"
            lazy
            row-key="id"
            :load="loadGoods"
          >
            <el-table-column
              header-align="left"
              align="left"
              prop="relGoodsName"
              label="商品名称"
            ></el-table-column>
            <el-table-column
              header-align="left"
              align="center"
              prop="categoryLevel"
              label="目标销量百分比"
            >
              <template slot-scope="scope">
                <div class="flex item-center">
                  <el-progress
                    :color="customColorMethod"
                    v-if="!isNaN(scope.row.percentage)"
                    style="width: 240px"
                    :show-text="false"
                    :stroke-width="12"
                    :percentage="scope.row.percentage"
                  ></el-progress>
                  <span class="ml10">{{ scope.row.percentage }}%</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="categoryLevel"
              label="当前销量/目标销量"
            >
              <template slot-scope="scope">
                <div>
                  <span
                    :class="
                      scope.row.detailGoalTaskValue <
                      scope.row.detailConfirmTaskValue
                        ? 'danger'
                        : 'success'
                    "
                    >{{ scope.row.detailGoalTaskValues }}</span
                  >
                  /{{ scope.row.detailConfirmTaskValues }}
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="mb20">
          <el-table
            :data="shopList"
            style="width: 100%"
            stripe
            size="small"
            :max-height="400"
            lazy
            row-key="id"
            :load="load"
            border
            :header-cell-style="{ background: '#f1f1f1', color: '#606266' }"
            :tree-props="{
              children: 'children',
              hasChildren: 'isHaveChildren'
            }"
          >
            <el-table-column
              header-align="left"
              align="left"
              prop="shopName"
              label="门店名称（14家）"
            >
              <template slot="header" slot-scope="scope">
                门店名称({{ shopList.length }})
              </template>
            </el-table-column>
            <el-table-column
              header-align="left"
              align="center"
              prop="categoryLevel"
              label="目标销量百分比"
              width="350"
            >
              <template slot-scope="scope">
                <div class="flex item-center">
                  <el-progress
                    :color="customColorMethod"
                    v-if="!isNaN(scope.row.percentage)"
                    style="width: 240px"
                    :show-text="false"
                    :stroke-width="12"
                    :percentage="scope.row.percentage"
                  ></el-progress>
                  <span class="ml10">{{ scope.row.percentage }}%</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="categoryLevel"
              label="当前销量/目标销量"
            >
              <template slot-scope="scope">
                <div>
                  <span
                    :class="
                      scope.row.detailGoalTaskValue <
                      scope.row.detailConfirmTaskValue
                        ? 'danger'
                        : 'success'
                    "
                    >{{ scope.row.detailGoalTaskValues }}</span
                  >
                  /{{ scope.row.detailConfirmTaskValues }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="realName"
              label="负责人"
            >
            </el-table-column>
          </el-table>
        </div>
      </div>

      <div slot="footer" class="dialog-footer flex flex-center">
        <el-button @click="dialogVisible = false" type="primary" size="small"
          >关闭</el-button
        >
      </div>
    </el-dialog>
  </div>

  <!-- </hm-content> -->
</template>

<script>
import { toPrice } from "@/utils/utils";
import VeHistogram from "v-charts/lib/histogram.common";
export default {
  components: { VeHistogram },
  data() {
    var self = this;
    this.chartEvents = {
      click: function(e) {
        self.goSplitTarget(e);
      }
    };
    return {
      url: "https://imgcdn.hemiao100.com/ThemePictures/okr-home.png",
      basicInfoModel: {},
      detailInfoModel: {},
      shopList: [],
      goodsList: [],
      details: {
        basicInfoModel: {},
        detailInfoModel: {},
        detailInfoModelList: [],
        shopDetailInfoModelList: []
      },
      title: "",
      dialogVisible: false,
      row: {
        // targetId: "b5a9d29cb92e4f0a94e8a7eedc2446ff",
        // planId: "37c75f4ecb7547358fb0d6d34e7ea0a5",
        // timeValue: "2020-11",
        // timeType: "month"
      },
      extend: {
        // 图标顶部的标题及按钮
        legend: {
          show: false
        },
        xAxis: {
          type: "category",
          show: true,
          // 坐标轴轴线
          axisLine: {
            show: true
          },
          // 坐标轴刻度
          axisTick: {
            show: true,
            inside: true,
            length: 10
          },
          // 坐标轴每项的文字
          axisLabel: {
            showMaxLabel: true,
            showMinLabel: true,
            color: "#000",
            rotate: 0, //刻度文字旋转，防止文字过多不显示
            margin: 8, //文字离x轴的距离
            boundaryGap: true,
            // backgroundColor:'#0f0',
            formatter: v => {
              // console.log('x--v',v)
              if (v.length > 3) {
                // return v.substring(0, 3) + "...";
              }
              return v;
            }
          }
        },
        yAxis: {
          show: false,
          offset: 0,
          // 坐标轴轴线
          axisLine: {
            show: false
          },
          // x轴对应的竖线
          splitLine: {
            show: false
          },
          // 坐标轴刻度
          axisTick: {
            show: false
          },
          boundaryGap: false,
          axisLabel: {
            color: "#3a3a3a"
          }
        },
        // 柱形区域
        grid: {
          left: 0
          // show: true
          // backgroundColor: "#FFF6F3",
          // borderColor: "#FFF6F3"
          // containLabel:false,
        },
        // 每个柱子
        series(v) {
          // 设置柱子的样式
          self.index++;
          v.forEach(i => {
            i.barWidth = "50%";
            i.itemStyle = {
              // barBorderRadius: [10, 10, 10, 10],
              // color: "#FF6633",
              aa: "1",
              opacity: 1.67,
              borderColor: "rgba(31, 31, 31, 1)",
              borderWidth: 3.5,
              normal: {
                opacity: 0.67,
                borderColor: "rgba(31, 31, 31, 1)",
                borderWidth: 1,
                color: function(params) {
                  var colorList = [
                    // "#FF0000",
                    "#2FC348",
                    "#DDDDDD",
                    "#DDDDDD",
                    "#DDDDDD",
                    "#DDDDDD"
                  ];
                  if (self.isSplit(params)) {
                    return colorList[0];
                  } else {
                    return colorList[1];
                  }
                }
              }
            };
            i.label = {
              color: "#666",
              show: true,
              position: "top",
              formatter: params => {
                // console.log("params", params);
                if (self.isSplit(params)) {
                  let html = ["{a|已拆分}", `{b|${params.value}}`].join("\n");
                  return html;
                } else {
                  let html = ["{c|待拆分}", `{b|${params.value}}`].join("\n");

                  return html;
                }
              },
              rich: {
                a: {
                  color: "#fff",
                  lineHeight: 20,
                  height: 20,
                  width: 44,
                  backgroundColor: "#2FC348",
                  align: "center",
                  borderRadius: 4
                },
                b: {
                  color: "#222",
                  height: 20,
                  align: "center"
                },
                c: {
                  color: "#fff",
                  lineHeight: 20,
                  height: 20,
                  width: 44,
                  backgroundColor: "#FF0007",
                  align: "center",
                  borderRadius: 4
                },
                x: {
                  fontSize: 18,
                  fontFamily: "Microsoft YaHei",
                  borderColor: "#449933",
                  borderRadius: 4
                }
              }
              // backgroundColor:'yellow',
            };
            i.markPoint = {
              data: [
                {
                  type: "max"
                }
              ],
              symbol: "pin"
            };
          });
          return v;
        }
      },
      chartData: {
        columns: ["日期", "访问用户", "下单用户", "下单率"],
        rows: [
          { 日期: "1/1", 访问用户: 1393, 下单用户: 1093, 下单率: 0.32 },
          { 日期: "1/2", 访问用户: 3530, 下单用户: 3230, 下单率: 0.26 },
          { 日期: "1/3", 访问用户: 2923, 下单用户: 2623, 下单率: 0.76 },
          { 日期: "1/4", 访问用户: 1723, 下单用户: 1423, 下单率: 0.49 },
          { 日期: "1/5", 访问用户: 3792, 下单用户: 3492, 下单率: 0.323 },
          { 日期: "1/6", 访问用户: 4593, 下单用户: 4293, 下单率: 0.78 }
        ]
      },
      active: 1,
      stepList: [
        {
          title: "1.目标拆分",
          icon: "icon-chaifenmubiao",
          doing: "进入目标拆分流程",
          complete: "目标已拆分完毕",
          disable: "当前尚未开启"
        },
        {
          title: "2.确认分时段目标",
          icon: "icon-zhuzhuangtu",
          doing: "确认分时段目标",
          complete: "计划已执行结束",
          disable: "当前尚未开启"
        },
        {
          title: "3.跟踪执行",
          icon: "icon-genzongzhihang",
          doing: "进入目标跟踪流程",
          complete: "计划已执行结束",
          disable: "当前尚未开启"
        },
        {
          title: "4.结果报告",
          icon: "icon-jieguobaogao1",
          doing: "报告已生成，请查收计划分析报告",
          complete: "报告已生成完毕",
          disable: "当前尚未开启"
        }
      ],
      list: [],
      index: 0,
      treeList: [
        {
          id: 1,
          name: "1"
        },
        {
          id: 2,
          name: "1-1",
          parentId: 1
        },
        {
          id: 3,
          name: "1-1-1",
          parentId: 2
        },
        {
          id: 4,
          name: "1-2",
          parentId: 1
        },
        {
          id: 5,
          name: "1-2-2",
          parentId: 4
        },
        {
          id: 6,
          name: "1-1-1-1",
          parentId: 3
        },
        {
          id: 7,
          name: "2"
        }
      ]
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.queryOkrPlanSplitTargetInfoByEmployee();
    this.index = 0;
    // console.log(this.test(this.treeList));
  },
  methods: {
    test(data) {
      //没有父节点的数据
      let parents = data.filter(
        value => value.parentId == "undefined" || value.parentId == null
      );

      //有父节点的数据
      let childrens = data.filter(
        value => value.parentId !== "undefined" && value.parentId != null
      );
      //定义转换方法的具体实现
      let translator = (parents, childrens) => {
        //遍历父节点数据
        parents.forEach(parent => {
          //遍历子节点数据
          childrens.forEach((current, index) => {
            //此时找到父节点对应的一个子节点
            if (current.parentId === parent.id) {
              //对子节点数据进行深复制，这里只支持部分类型的数据深复制，对深复制不了解的童靴可以先去了解下深复制
              let temp = JSON.parse(JSON.stringify(childrens));
              //让当前子节点从temp中移除，temp作为新的子节点数据，这里是为了让递归时，子节点的遍历次数更少，如果父子关系的层级越多，越有利
              temp.splice(index, 1);
              //让当前子节点作为唯一的父节点，去递归查找其对应的子节点
              translator([current], temp);
              //把找到子节点放入父节点的childrens属性中
              typeof parent.childrens !== "undefined"
                ? parent.childrens.push(current)
                : (parent.childrens = [current]);
            }
          });
        });
      };

      //调用转换方法
      translator(parents, childrens);

      //返回最终的结果
      return parents;
    },
    add() {
      this.$router.push({
        name: "OkrWorkDevelop"
      });
    },
    loadGoods(tree, treeNode, resolve) {
      this.$store.dispatch("queryTargetSplitGoodsDetail", tree).then(res => {
        if (res.code === "0" && res.result.length) {
          res.result.forEach(v => {
            v.percentage =
              Math.floor(
                (v.detailGoalTaskValue / v.detailConfirmTaskValue) * 10000
              ) / 100;
          });
          resolve(res.result);
        } else {
          resolve([]);
        }
      });
    },
    customColorMethod(percentage) {
      if (percentage >= 100) {
        return "#67c23a";
      }
    },
    async queryDetailsList() {
      let params = {
        planId: this.row.planId,
        targetId: this.row.targetId,
        timeValue: this.row.timeValue
      };
      const { code, result } = await this.$store.dispatch(
        "queryTargetSplitDetail",
        params
      );
      if (code === "0") {
        const {
          detailInfoModelList,
          shopDetailInfoModelList,
          basicInfoModel,
          detailInfoModel
        } = result;

        detailInfoModel.percentage =
          Math.floor(
            (detailInfoModel.detailGoalTaskValue /
              detailInfoModel.detailConfirmTaskValue) *
              10000
          ) / 100;
        detailInfoModel.detailGoalTaskValues = toPrice(
          detailInfoModel.detailGoalTaskValue
        );
        detailInfoModel.detailConfirmTaskValues = toPrice(
          detailInfoModel.detailConfirmTaskValue
        );
        detailInfoModelList.forEach(v => {
          v.percentage =
            Math.floor(
              (v.detailGoalTaskValue / v.detailConfirmTaskValue) * 10000
            ) / 100;
          v.detailGoalTaskValues = toPrice(v.detailGoalTaskValue);
          v.detailConfirmTaskValues = toPrice(v.detailConfirmTaskValue);
        });
        shopDetailInfoModelList.forEach(v => {
          v.isHaveChildren = true;
          v.percentage =
            Math.floor(
              (v.detailGoalTaskValue / v.detailConfirmTaskValue) * 10000
            ) / 100;
          v.detailGoalTaskValues = toPrice(v.detailGoalTaskValue);
          v.detailConfirmTaskValues = toPrice(v.detailConfirmTaskValue);
        });
        basicInfoModel.toPrice = toPrice(basicInfoModel.planValue.toFixed(2));
        this.basicInfoModel = basicInfoModel;
        this.detailInfoModel = detailInfoModel;
        this.shopList = shopDetailInfoModelList;
        this.goodsList = detailInfoModelList;

        this.dialogVisible = true;
      }
    },
    load(tree, treeNode, resolve) {
      this.$store.dispatch("queryTargetSplitEmployeeDetail", tree).then(res => {
        if (res.code === "0" && res.result.length) {
          res.result.forEach(v => {
            v.percentage =
              Math.floor(
                (v.detailGoalTaskValue / v.detailConfirmTaskValue) * 10000
              ) / 100;
          });
          resolve(res.result);
        } else {
          resolve([]);
        }
      });
    },
    isSplit(e) {
      if (
        this.list[this.index - 1].targetInfoModelList[e.dataIndex]
          .splitState === "yes"
      ) {
        return true;
      } else {
        return false;
      }
    },
    goSplitTarget(e) {
      setTimeout(() => {
        if (
          this.list[this.index].targetInfoModelList[e.dataIndex].splitState ===
          "yes"
        ) {
          this.row = this.list[this.index].targetInfoModelList[e.dataIndex];
          this.title = this.row.timeValue + "详情";
          this.queryDetailsList();
        } else {
          this.$router.push({
            name: "AffirmOkrWorkSplit",
            query: {
              row: JSON.stringify(
                this.list[this.index].targetInfoModelList[e.dataIndex]
              )
            }
          });
        }
      });
    },
    getIndex(i) {
      this.index = i;
    },
    goDetails(row) {
      this.$router.push({
        name: "SplitOkrWorkDetails",
        query: {
          targetId: row.targetId
        }
      });
    },
    goSplit(row) {
      let params = {};
      for (let key in row) {
        if (key !== "pageNo" && key !== "pageSize") {
          params[key] = row[key];
        }
      }

      this.$router.push({
        name: "SplitOkrWork",
        query: {
          row: JSON.stringify(params)
        }
      });
    },
    async queryOkrPlanSplitTargetInfoByEmployee() {
      const { code, result } = await this.$store.dispatch(
        "queryOkrPlanSplitTargetInfoByEmployee"
      );
      if (code === "0") {
        result.forEach((v, i) => {
          if (v.targetState === "createTarget") {
            v.active = 1;
          } else if (v.targetState === "splitTarget") {
            v.active = 2;
          } else if (v.targetState === "trackingExecution") {
            v.active = 3;
          } else if (v.targetState === "resultsReports") {
            v.active = 4;
          }
          v.chartData = {
            columns: ["时间", "目标值"],
            rows: []
          };
          v.extend = {
            // 图标顶部的标题及按钮
            legend: {
              show: false
            },
            xAxis: {
              type: "category",
              show: true,
              // 坐标轴轴线
              axisLine: {
                show: true
              },
              // 坐标轴刻度
              axisTick: {
                show: true,
                inside: true,
                length: 10
              },
              // 坐标轴每项的文字
              axisLabel: {
                showMaxLabel: true,
                showMinLabel: true,
                color: "#000",
                rotate: 0, //刻度文字旋转，防止文字过多不显示
                margin: 8, //文字离x轴的距离
                boundaryGap: true,
                // backgroundColor:'#0f0',
                formatter: v => {
                  // console.log('x--v',v)
                  if (v.length > 3) {
                    // return v.substring(0, 3) + "...";
                  }
                  return v;
                }
              }
            },
            yAxis: {
              show: false,
              offset: 0,
              // 坐标轴轴线
              axisLine: {
                show: false
              },
              // x轴对应的竖线
              splitLine: {
                show: false
              },
              // 坐标轴刻度
              axisTick: {
                show: false
              },
              boundaryGap: false,
              axisLabel: {
                color: "#3a3a3a"
              }
            },
            // 柱形区域
            grid: {
              left: 0
              // show: true
              // backgroundColor: "#FFF6F3",
              // borderColor: "#FFF6F3"
              // containLabel:false,
            },
            series: {
              barWidth: "30%",
              itemStyle: {
                opacity: 0.67,
                borderColor: "rgba(31, 31, 31, 1)",
                borderWidth: 1.5,
                normal: {
                  opacity: 0.67,
                  borderColor: "rgba(31, 31, 31, 1)",
                  borderWidth: 1,
                  color: function(params) {
                    if (
                      result[i].targetInfoModelList[params.dataIndex]
                        .splitState === "yes"
                    ) {
                      return "#2FC348";
                    } else {
                      return "#DDDDDD";
                    }
                    // var colorList = [
                    //   // "#FF0000",
                    //   "#2FC348",
                    //   "#DDDDDD",
                    //   "#DDDDDD",
                    //   "#DDDDDD",
                    //   "#DDDDDD"
                    // ];
                    // if (this.isSplit(params)) {
                    //   return colorList[0];
                    // } else {
                    //   return colorList[1];
                    // }
                  }
                }
              },

              label: {
                color: "#666",
                show: true,
                position: "top",
                formatter: params => {
                  // console.log("params", params);
                  if (
                    result[i].targetInfoModelList[params.dataIndex]
                      .splitState === "yes"
                  ) {
                    let html = ["{a|已拆分}", `{b|${params.value}}`].join("\n");
                    return html;
                  } else {
                    let html = ["{c|待拆分}", `{b|${params.value}}`].join("\n");

                    return html;
                  }
                },
                rich: {
                  a: {
                    color: "#fff",
                    lineHeight: 20,
                    height: 20,
                    width: 44,
                    backgroundColor: "#2FC348",
                    align: "center",
                    borderRadius: 4
                  },
                  b: {
                    color: "#222",
                    height: 20,
                    align: "center"
                  },
                  c: {
                    color: "#fff",
                    lineHeight: 20,
                    height: 20,
                    width: 44,
                    backgroundColor: "#FF0007",
                    align: "center",
                    borderRadius: 4
                  },
                  x: {
                    fontSize: 18,
                    fontFamily: "Microsoft YaHei",
                    borderColor: "#449933",
                    borderRadius: 4
                  }
                }
              }
            }
          };

          if (v.targetInfoModelList && v.targetInfoModelList.length) {
            v.targetInfoModelList.forEach(o => {
              o.目标值 = o.splitValue;
              o.时间 = o.timeValue;
              o.index = i;
              v.chartData.rows.push(o);
            });
          }
        });
        this.list = result;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.bor-m {
  border-bottom: 1px solid #f4f4f4;
}
.okr-title {
  font-weight: 600;
  padding: 0 10px;
  height: 70px;
  font-size: 17px;
  // div {
  //   margin-right: 80px;
  // }
}
.okr {
  background: #ffffff;
  border-left: 6px solid #e50065;
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;

  .bor-m {
    border-bottom: 1px solid #f4f4f4;
  }
  .okr-title {
    font-weight: 600;
    // padding: 0 10px;
    height: 70px;
    font-size: 17px;
    // div {
    //   // margin-right: 10px;
    // }
  }
  .circular {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: 1px solid #dddddd;
    .hmicon {
      color: #999;
    }
  }
  .circular-active {
    background: #e50065;
    .hmicon {
      color: #fff;
    }
  }
}
</style>
